import { addDays, format, isSameDay } from "date-fns";

const formatDatepickerOptions = (reservationWindow, closures, today) => {
	const DEFAULT_OPTION = {
		value: "",
		label: "",
		disabled: true
	};

	// Week
	const weeksWithDividers = (dates) => {
		const result = [];

		dates.forEach((date) => {
			if (date.label.includes("Sunday")) {
				result.push({
					value: "",
					label: "---------",
					disabled: true
				});
			}

			result.push(date);
		});

		return result;
	};


	const createOptions = () => {
		const dates = Array.from(
			{ length: reservationWindow + 1 },
			(_, k) => addDays(today, k)
		).map((date) => ({
			value: format(date, "MM/dd/yyyy"),
			label: format(date, "iiii, MMMM d"),
			disabled: closures.some((closure) =>
				isSameDay(addDays(new Date(closure), 1), date)
			)
		}));

		return [DEFAULT_OPTION, ...weeksWithDividers(dates)];
	};

	return {
		options: createOptions()
	};
};

export default formatDatepickerOptions;
